// Area data for programmatic SEO landing pages
const areaData = {
    'chippenham': {
        name: 'Chippenham',
        county: 'Wiltshire',
        distance: '15 minutes',
        description: 'Chippenham dog owners love our mantrailing sessions in the Wiltshire countryside. Just a short drive from Chippenham, Craven Canines offers expert-led scent work training for dogs of all breeds and ages.',
        nearby: ['Corsham', 'Calne', 'Malmesbury']
    },
    'swindon': {
        name: 'Swindon',
        county: 'Wiltshire',
        distance: '25 minutes',
        description: 'Looking for mantrailing near Swindon? Craven Canines runs professional scent work sessions in the beautiful North Wiltshire countryside, easily accessible from Swindon.',
        nearby: ['Royal Wootton Bassett', 'Highworth', 'Malmesbury']
    },
    'corsham': {
        name: 'Corsham',
        county: 'Wiltshire',
        distance: '20 minutes',
        description: 'Corsham dog enthusiasts can join our mantrailing sessions near Malmesbury. A perfect activity for building confidence, strengthening your bond, and giving your dog incredible mental enrichment.',
        nearby: ['Chippenham', 'Box', 'Malmesbury']
    },
    'tetbury': {
        name: 'Tetbury',
        county: 'Gloucestershire',
        distance: '10 minutes',
        description: 'Tetbury is one of the closest towns to our regular mantrailing locations. Dog owners from Tetbury and the Cotswolds regularly attend our sessions near Malmesbury.',
        nearby: ['Nailsworth', 'Cirencester', 'Malmesbury']
    },
    'bath': {
        name: 'Bath',
        county: 'Somerset',
        distance: '30 minutes',
        description: 'Bath dog owners looking for something different will love mantrailing with Craven Canines. Our sessions in the Wiltshire countryside offer a refreshing change from city walks.',
        nearby: ['Bradford-on-Avon', 'Corsham', 'Malmesbury']
    },
    'cirencester': {
        name: 'Cirencester',
        county: 'Gloucestershire',
        distance: '20 minutes',
        description: 'Cirencester and Cotswolds dog owners can easily reach our mantrailing sessions near Malmesbury. Expert-led scent work that taps into your dog\'s natural tracking instincts.',
        nearby: ['Tetbury', 'Fairford', 'Malmesbury']
    },
    'calne': {
        name: 'Calne',
        county: 'Wiltshire',
        distance: '15 minutes',
        description: 'Calne dog lovers are perfectly placed to enjoy mantrailing with Craven Canines. Our sessions near Malmesbury provide fantastic mental stimulation and confidence building for all dogs.',
        nearby: ['Chippenham', 'Devizes', 'Malmesbury']
    },
    'devizes': {
        name: 'Devizes',
        county: 'Wiltshire',
        distance: '25 minutes',
        description: 'Devizes dog owners can discover the joy of mantrailing with Craven Canines. Professional scent work sessions in North Wiltshire that your dog will absolutely love.',
        nearby: ['Calne', 'Trowbridge', 'Malmesbury']
    },
    'trowbridge': {
        name: 'Trowbridge',
        county: 'Wiltshire',
        distance: '25 minutes',
        description: 'Trowbridge residents looking for enriching dog activities will find mantrailing an incredible experience. Craven Canines offers sessions suitable for all breeds and abilities.',
        nearby: ['Bradford-on-Avon', 'Melksham', 'Malmesbury']
    },
    'bradford-on-avon': {
        name: 'Bradford-on-Avon',
        county: 'Wiltshire',
        distance: '25 minutes',
        description: 'Bradford-on-Avon dog owners can enjoy mantrailing in the Wiltshire countryside with Craven Canines. A low-impact sport perfect for dogs who love to sniff and explore.',
        nearby: ['Bath', 'Trowbridge', 'Malmesbury']
    }
};

export const areaList = Object.keys(areaData);

export default areaData;
